export default {
  properties: {
    value: {
      fieldRequired: true,
      title: 'Adres skrytki ePUAP',
      type: 'string',
      validFunc: '/^\\/.+\\/.+/.test($value)',
      validationMessages: {
        validFunc: 'Należy podać prawidłowy adres skrytki ePUAP, w formacie "/login_w_epuap/nazwa_skrytki"'
      }
    },
    documentId: { type: 'number' },
    code: { type: 'string' }
  }
};
